import {
  AddPhotoAlternate,
  Delete,
  Edit,
  ImageOutlined,
} from "@mui/icons-material";
import {
  Button,
  Card,
  CardContent,
  Chip,
  Grid,
  Paper,
  Stack,
  Tooltip,
  Typography,
  Box,
} from "@mui/material";

export default function CardListing({
  title,
  data,
  onEdit,
  onDelete,
  onAdd,
  onPreview,
  size,
}) {
  return (
    <>
      {data.length === 0 ? (
        <Paper
          elevation={0}
          sx={{
            p: 6,
            textAlign: "center",
            borderRadius: 3,
            border: "2px dashed",
            borderColor: "divider",
            bgcolor: "background.default",
          }}
        >
          <ImageOutlined sx={{ fontSize: 64, color: "text.disabled", mb: 2 }} />
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No {title}s yet
          </Typography>
          <Typography variant="body2" color="text.disabled" mb={3}>
            Create your first {title} to get started
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddPhotoAlternate />}
            onClick={onAdd}
          >
            Add First {title}
          </Button>
        </Paper>
      ) : (
        <Grid container spacing={3}>
          {data.map((item, index) => (
            <Grid item key={item.id || item._id || index} size={size.width}>
              <Card
                elevation={3}
                sx={{
                  borderRadius: 16 / 8,
                  position: "relative",
                  overflow: "hidden",
                  width: "100%",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: 6,
                  },
                }}
              >
                {/* Image Container */}
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                    cursor: "pointer",
                    position: "relative",
                    bgcolor: "grey.100",
                  }}
                  onClick={() => onPreview(item.url)}
                >
                  <img
                    src={item.url}
                    alt={`${title} ${index + 1}`}
                    style={{
                      width: "100%",
                      maxHeight: size.height,
                      objectFit: "cover",
                      transition: "transform 0.3s ease",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.transform = "scale(1.05)")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  />

                  {/* Order Badge */}
                  <Chip
                    label={`Order: ${item.order}`}
                    size="small"
                    sx={{
                      position: "absolute",
                      top: 12,
                      right: 12,
                      bgcolor: "primary.main",
                      color: "white",
                      fontWeight: 600,
                      boxShadow: 2,
                    }}
                  />

                  {/* Hover Overlay */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      bgcolor: "rgba(0,0,0,0.4)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      opacity: 0,
                      transition: "opacity 0.3s ease",
                      "&:hover": {
                        opacity: 1,
                      },
                    }}
                  >
                    <Typography variant="body2" color="white" fontWeight={500}>
                      Click to preview
                    </Typography>
                  </Box>
                </Box>

                {/* Action Buttons */}
                <CardContent sx={{ p: 2, bgcolor: "background.paper" }}>
                  <Stack direction="row" spacing={1} justifyContent="center">
                    <Tooltip title={`Edit ${title}`}>
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<Edit />}
                        onClick={() => onEdit(item)}
                        sx={{
                          flex: 1,
                          borderRadius: 2,
                        }}
                      >
                        Edit
                      </Button>
                    </Tooltip>

                    <Tooltip title={`Delete ${title}`}>
                      <Button
                        variant="outlined"
                        size="small"
                        color="error"
                        startIcon={<Delete />}
                        onClick={() => onDelete(item)}
                        sx={{
                          flex: 1,
                          borderRadius: 2,
                        }}
                      >
                        Delete
                      </Button>
                    </Tooltip>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
}
